import { Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
  Text
} from "@chakra-ui/react";
import { INFERENCES_CLASSES } from "../utils";
import Overline from "./Overline";

type Props = {
  color: string;
}

const Circle = ({ color }: Props) => (
  <Box
    display="inline-block"
    bgColor={color}
    borderRadius="50%"
    height="4"
    minWidth="4"
  />);

const MapSpeciesLegend = () => (
  <Box display="flex" flexDir="column" gap="1">
    <Overline fontSize="sm" fontWeight="500">
      Species Detections
    </Overline>
    {Object.values(INFERENCES_CLASSES).filter((i) => i.isWhale).map((i) => (
      <Box display="flex" alignItems="center" gap="2" key={i.label}>
        <Circle color={i.color} />
        <Text fontWeight="bold" fontSize="sm">{i.label}</Text>
      </Box>
    ))}
    <Accordion allowToggle mt="1">
      <AccordionItem border="none">
        <h2>
          <AccordionButton p="0" py="1">
            <Overline fontSize="sm" fontWeight="500">
      Non-Species Detections
            </Overline>
            <AccordionIcon />
          </AccordionButton>
        </h2>
        <AccordionPanel p={0} display="flex" flexDir="column" gap="1">
          {Object.values(INFERENCES_CLASSES).filter((i) => !i.isWhale).map((i) => (
            <Box display="flex" alignItems="center" gap="2" key={i.label}>
              <Circle color={i.color} />
              <Text fontWeight="bold" fontSize="sm">{i.label}</Text>
            </Box>
          ))}
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  </Box>
);

export default MapSpeciesLegend;
